module.exports = __webpack_public_path__ + "static/media/wifi-header.93674797.webp";